import { BaseResponseDTO } from "@app/shared/dto/base-responseDTO";
import { PaginazioneDTO } from "@app/shared/dto/paginazioneDTO";

export class ResultListDTO<T> extends BaseResponseDTO {
  paginazione: PaginazioneDTO;
  resultList: T[];
}
